module.exports = __webpack_public_path__ + "img/title.74d6bf29.png";